<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <h5 class="mt-4">
      <b-badge variant="info"
        >Container Details : {{ allContainersDataArray.length }} Container
      </b-badge>
    </h5>
    <table class="table table-sm mt-2 shadow p-3 mb-5 bg-white rounded">
      <tbody>
        <tr v-if="TYPE == 'IMPORT'">
          <th bgcolor="whiteSmoke" style="width: 20px">
            <b-form-checkbox
            :disabled="viewPagePref==1"
              v-model="checkAll"
              style="height: 2px !important"
              class="align-center"
              size="lg"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </th>
          <th bgcolor="whiteSmoke">Container Type & No.</th>
          <th v-if="JOB == 'CC'">Shipping Bills</th>
          <th v-if="JOB == 'CC'">Shipper Invoices</th>
          <th>Rail Out Date</th>
          <th>ICD Arrival Date</th>
          <th>Free Days Upto</th>

          <!-- <th>Other</th> -->
        </tr>
        <tr v-else>
          <th bgcolor="whiteSmoke" style="width: 20px">
            <b-form-checkbox
            :disabled="viewPagePref==1"
              v-model="checkAll"
              style="height: 2px !important"
              class="align-center"
              size="lg"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
          </th>
          <th bgcolor="whiteSmoke">Container Type & No.</th>
          <th>Wgt. & Measurement</th>
          <th>Custom & Line Seal No.</th>
          <th>Shipping Bills</th>
          <th>Shipper Invoices</th>
          <th>Other</th>
        </tr>
        <tr v-for="(item, index) in allContainersDataArray" :key="index">
          <td
            style="text-align: center; vertical-align: middle; width: 20px"
            bgcolor="whiteSmoke"
          >
            <b-form-checkbox
            :disabled="viewPagePref==1"
              size="lg"
              v-model="singleSelectContainer"
              :value="item.uniqueContainerId"
            ></b-form-checkbox>
          </td>
          <td
            style="text-align: left; vertical-align: middle; width: 200px"
            bgcolor="whiteSmoke"
          >
          <span
                v-if="item.sub_noti_event_code == 4"
                :class="{
                  alert: true,
                  'alert-danger-text': item.sub_noti_event_code == 4,
                  blink: item.sub_noti_event_code == 4,
                }"
                >This Container has been Rolled Over<br /></span
              >
            <b-button
            :disabled="viewPagePref==1"
              @click="showModal(item.uniqueContainerId, index)"
              size="sm"
              variant="outline-info"
              >{{ item.containerType }} <i class="fa fa-edit"></i></b-button
            ><b v-if="item.containerNo" class="ml-2"
           ><br /><br />{{ item.containerNo }}</b
            >
            <b v-if="item.sub_noti_event_message" class="ml-2 text-danger"
              ><br />Event MSG : {{ item.sub_noti_event_message }}</b
            >
          </td>
          <td v-if="TYPE != 'IMPORT'">
            Net Wgt. : {{ item.netWeight }}<br />Gross Wgt. : {{ item.grossWeight
            }}<br />Tare Wgt. : {{ item.tareWeight }}<br />Unit :{{ item.weightUnit
            }}<br />Measurement :
            {{ item.measurement }}
          </td>
          <td v-if="TYPE != 'IMPORT'">
            Custom Seal : {{ item.customSealNo }}<br />
            Line Seal : {{ item.LineSealNo }}
          </td>
          <td v-if="TYPE != 'IMPORT'">
            SB No. : {{ item.shippingBillNo }}<br />
            SB Date :
            {{ item.shippingBillDate ? item.shippingBillDate.split(" ")[0] : "" }}
          </td>
          <td v-if="TYPE != 'IMPORT'">
            Shipper Inv No. : {{ item.shipperInvoiceNo }}<br />
            Date :
            {{ item.shipperInvoiceDate ? item.shipperInvoiceDate.split(" ")[0] : "" }}
          </td>
          <td v-if="TYPE != 'IMPORT'">
            Package : {{ item.packageName }}<br />
            No.of Package : {{ item.noOfpkgUnit }}

            <span v-if="JOB == 'CC'"
              ><br />Booking No. : {{ item.containerBookingNo }}
            </span>
          </td>
          <td v-if="TYPE == 'IMPORT' && JOB == 'CC'">
            SB No. : {{ item.shippingBillNo }}<br />
            SB Date :
            {{ item.shippingBillDate ? item.shippingBillDate.split(" ")[0] : "" }}
          </td>
          <td v-if="TYPE == 'IMPORT' && JOB == 'CC'">
            Shipper Inv No. : {{ item.shipperInvoiceNo }}<br />
            Date :
            {{ item.shipperInvoiceDate ? item.shipperInvoiceDate.split(" ")[0] : "" }}
          </td>
          <td v-if="TYPE == 'IMPORT'">{{ item.importPortETAorRailOutDt }}</td>
          <td v-if="TYPE == 'IMPORT'">{{ item.importCFSorArrivalDt }}</td>
          <td v-if="TYPE == 'IMPORT'">{{ item.importFreeDaysUpto }}</td>
        </tr>
      </tbody>
    </table>

    <div>
      <b-modal
        size="xl"
        ref="my-modal-con"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        title=""
      >
        <div class="d-block text-left">
          <h6 style="color: green"><u>CONTAINER DETAILS</u></h6>

          <span class="error">* Marked Field are mandatory..!!</span>
        </div>
        <!-- <div>
          <b-form-checkbox
            style="
              height: 0;
              padding-left: 10;
              font-size: 1.25rem;
              line-height: 0;
              border-radius: 0.3rem;

              height: 2px;
            "
            size="lg"
          ></b-form-checkbox
          ><span class="ml-4"><b>Uncheck in case not same for all</b></span>
        </div> -->
        <div class="gutr">
          <b-card style="background: whiteSmoke">
            <md-layout md-gutter>
              <span v-if="containerNoRegexError != ''"
                ><b>{{ containerNoRegexError }}</b></span
              >
              <h5 class="ml-2 mr-2 error" v-if="conAlreadyExists != ''">
                <b>{{ conAlreadyExists }}</b>
              </h5>
              <span
                v-if="
                  containerNoRegexError == '' &&
                  containerModal.containerNo != '' &&
                  containerModal.containerNo != algoConNo &&
                  showAlgo == true
                "
                ><b>Note : System Generated Container No. is : {{ algoConNo }}</b></span
              >
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Container No*. (eg. AAAA1234567)</label>
                  <!--
                      && ($sessionsStorage.get('designation') == 'Admin' )-->
                  <!-- {{$sessionsStorage.get('designation')}} 
                      ((containerModal.EnabledContainerFeild == true && containerModal.containerNoUpdateCounter==0))
                        ? false
                        : true EnabledContainerFeild
                    -->
                  <!-- {{containerModal}} -->

                  <!-- :disabled="(JOB=='FF')?containerModal.EnabledContainerFeild:disableContainer" -->
                  <!-- {{ containerModal.containerInfo }}
                  {{ containerModal.EnabledContainerFeild }}
                  {{ JOB }}
                  {{ containerModal }} -->
                  <!-- {{ containerModal.EnabledContainerFeild }} -->
                  <!-- {{assignmentJobType}} -->
                  <b-form-input
                    :formatter="capitalizeAll"
                    :disabled="
                      assignmentJobType.includes('TPT') &&
                      containerModal.containerInfo == 'fcl' &&
                      assignmentType == 'Export'
                        ? true
                        : containerModal.containerNoUpdateCounter >= 3
                        ? true
                        : assignmentJobType == 'FF' &&
                          assignmentType == 'Export' &&
                          containerModal.containerInfo == 'lcl' &&
                          !containerModal.EnabledContainerFeild
                        ? false
                        : containerModal.jobType.includes('TPT') &&
                          containerModal.containerInfo == 'fcl' &&
                          assignmentType == 'Export' &&
                          containerModal.containerNoUpdateCounter >= 3
                        ? true
                        : JOB == 'FF'
                        ? containerModal.containerInfo == 'lcl' &&
                          containerModal.transportType == 'Export'
                          ? !containerModal.containerNo
                            ? true
                            : containerModal.EnabledContainerFeild
                          : false
                        : containerModal.containerNoUpdateCounter == 1 &&
                          containerModal.containerNo
                        ? true
                        : disableContainer
                    "
                    maxlength="11"
                    name="containerNo"
                    v-model="containerModal.containerNo"
                    @keyup="
                      containerNoRegexfun();
                      CheckContainerNumber();
                    "
                    @input="CheckContainerNumber()"
                  ></b-form-input>
                  <b :class="checkContNoButton == 1 ? 'success' : 'error'">
                    {{ timmerMsg }}
                  </b>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label for="containerType">Container Type/Size*</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="containerModal.containerType"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <b-form-checkbox
              v-model="checkAll"
              @change="selectAllContainers"
              style="height: 2px !important"
              class="align-center"
              size="lg"
              value="1"
              unchecked-value="0"
            ></b-form-checkbox>
            <h6 class="mt-2">
              Below Details Same For Selected
              {{ singleSelectContainer.length > 0 ? singleSelectContainer.length : "" }}
              Containers
            </h6>
            <div v-if="TYPE == 'IMPORT'">
              <md-layout md-gutter>
                <md-layout md-flex="20">
                  <label>Port ETA / Rail Out Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="importPortETAorRailOutDt"
                    name="importPortETAorRailOutDt"
                    v-model="containerModal.importPortETAorRailOutDt"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>CFS Arrival / ICD Arrival Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="importCFSorArrivalDt"
                    name="importCFSorArrivalDt"
                    v-model="containerModal.importCFSorArrivalDt"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Free Days Upto</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="importFreeDaysUpto"
                    name="importFreeDaysUpto"
                    v-model="containerModal.importFreeDaysUpto"
                  ></date-picker> </md-layout
              ></md-layout>
            </div>
            <div v-else>
              <md-layout md-gutter>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Line Seal No</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="LineSealNo"
                      name="LineSealNo"
                      v-model="containerModal.LineSealNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Custom Seal No</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="customSealNo"
                      name="customSealNo"
                      v-model="containerModal.customSealNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <label>Package Details</label>
                  <model-list-select
                    :list="packageNameList"
                    id="clientId"
                    v-model="containerModal.packageId"
                    option-value="packageId"
                    option-text="packageName"
                    placeholder="Select  Package Name"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <!-- ({{ containerModal.packageName }}) -->
                    <label>No. of Packages </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="noOfpkgUnit"
                      id="noOfpkgUnit"
                      type="number"
                      min="0"
                      :disabled="containerModal.packageName == '' ? true : false"
                      v-model="containerModal.noOfpkgUnit"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Container Tare Wgt.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="tareWeight"
                      name="tareWeight"
                      type="number"
                      min="0"
                      v-model="containerModal.tareWeight"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="10">
                  <md-layout md-flex="100">
                    <label>Net Wgt.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="netWeight"
                      name="netWeight"
                      type="number"
                      min="0"
                      v-model="containerModal.netWeight"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="10">
                  <md-layout md-flex="100">
                    <label>Gross Wgt.*</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="grossWeight"
                      name="grossWeight"
                      type="number"
                      min="0"
                      v-model="containerModal.grossWeight"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="10">
                  <label for="weightUnit">Unit*</label>
                  <model-list-select
                    :list="unitList"
                    option-value="uV"
                    option-text="uT"
                    placeholder="Select"
                    name="weightUnit"
                    id="weightUnit"
                    v-model="containerModal.weightUnit"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Measurement (in CBM)</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="noOfpkgUnit"
                      id="noOfpkgUnit"
                      type="number"
                      min="0"
                      v-model="containerModal.measurement"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr" v-if="JOB == 'FF'">
                <md-layout md-flex="30">
                  <label>Pickup Location</label>

                  <model-list-select
                    @input="getLocationList($event, 'All', 'pickUpListpickUpList')"
                    @searchchange="getLocationList($event, 'All', 'pickUpList')"
                    :list="pickUpList"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Search PickUp Location"
                    name="PickupLocation"
                    id="PickupLocation"
                    v-model="containerModal.PickupLocation"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <label>Handover Location</label>

                  <model-list-select
                    @input="getLocationList($event, 'All', 'handoverList')"
                    @searchchange="getLocationList($event, 'All', 'handoverList')"
                    :list="handoverList"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Handover Location"
                    name="StuffingLocation"
                    id="StuffingLocation"
                    v-model="containerModal.StuffingLocation"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Pickup Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="pickupDate"
                    :minute-step="1"
                    name="pickupDate"
                    v-model="containerModal.pickupDate"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Stuffing Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="stuffingDate"
                    :minute-step="1"
                    name="stuffingDate"
                    v-model="containerModal.stuffingDate"
                  ></date-picker>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" class="gutr">
                  <md-layout md-flex="100">
                    <label>Booking No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="containerBookingNo"
                      name="containerBookingNo"
                      v-model="containerModal.containerBookingNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Handover Date.*</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    name="HandoverDate"
                    id="HandoverDate"
                    v-model="containerModal.handoverDate"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </md-layout>
            </div>

            <div v-if="TYPE != 'IMPORT' || (JOB == 'CC' && TYPE == 'IMPORT')">
              <hr />
              <h6 class="mt-3">
                <b-badge variant="light"> Shipper Invoices & Shipping Bill </b-badge>
              </h6>
              <md-layout gutter>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Shipper Invoice No.*</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="shipperInvoiceNo"
                      id="shipperInvoiceNo"
                      v-model="containerModal.shipperInvoiceNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <label>Invoice Date.*</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    name="shippingBillDate"
                    id="shippingBillDate"
                    v-model="containerModal.shipperInvoiceDate"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Shipping Bill No.*</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="containerModal.shippingBillNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Shipping Bill Date*</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    name="shippingBillDate"
                    id="shippingBillDate"
                    v-model="containerModal.shippingBillDate"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </md-layout>
            </div>
            <div v-if="TYPE != 'IMPORT'">
              <md-layout md-gutter class="gutr" v-if="JOB == 'FF'">
                <md-layout md-flex="25">
                  <label for="examinationComplete">Examination Complete</label>
                  <model-list-select
                    :list="examinationList"
                    option-value="examValue"
                    option-text="examText"
                    placeholder="Select Examination"
                    name="examinationComplete"
                    id="examinationComplete"
                    v-model="containerModal.examinationComplete"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout
                  md-flex="15"
                  v-if="containerModal.examinationComplete == 'Yes'"
                >
                  <label>Examination Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="examDate"
                    :minute-step="1"
                    name="examDate"
                    v-model="containerModal.examDate"
                  ></date-picker>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout
                  md-flex="15"
                  v-if="containerModal.examinationComplete == 'Yes'"
                >
                  <label>LET Export Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="LetExport"
                    :minute-step="1"
                    name="LetExport"
                    v-model="containerModal.LetExportDate"
                  ></date-picker>
                </md-layout>
              </md-layout>
              <!-- v-if="mainEntryData[0].containerSealed == 'WareHouse'" -->
              <md-layout md-gutter class="gutr" v-if="JOB == 'CC'">
                <md-layout md-flex="25">
                  <label>CRN No.</label>

                  <b-input
                    name="Remark"
                    id="Remark"
                    v-model="containerModal.crnNo"
                  ></b-input>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Carting Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="bookingDate"
                    name="bookingDate"
                    v-model="containerModal.cartingDate"
                  ></date-picker>
                </md-layout>
              </md-layout>
            </div>
          </b-card>
        </div>
        <span class="error pull-right"
          ><b>{{ containerModal.UpdateReason }}</b></span
        >
        <b-button
          :disabled="isValidContainer ? true : checkContNoButton != 1 ? true : false"
          class="mt-3 pull-right"
          variant="success"
          @click="submitContainer"
          >Submit</b-button
        >
        <b-button class="mt-3" variant="outline-danger" @click="hideModal"
          >Cancel & Close</b-button
        >
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Confirmation"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <h4 class="error" v-if="validate">{{ containerNoRegexError }}</h4>
      <b-button @click="closeModalConfirm" variant="danger" class="pull-right">
        Close</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC, URL_NODE_BASE } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  props: ["allModuleIdContainer", "JOB", "TYPE"],
  beforeMount() {
    //      if(this.allModuleIdContainer){
    //      } else {
    //       // this.$router.push({
    //       //   path: "/dashboard",
    //       // });
    // }
  },

  data() {
    return {
      viewPagePref: this.$sessionsStorage.get("user_view_page_pref"),
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      validate: false,
      syncFlag: false,
      ContainernoErrFlag: false,
      OldAssSeries_Containerno: "",
      selectDateFormat,
      checkAll: "0",
      assignmentJobType: [],
      assignmentType: "",
      singleSelectContainer: [],
      pickUpList: [],
      handoverList: [],
      packageNameList: [],
      examinationList: [
        {
          examText: "Yes",
          examValue: "Yes",
        },
        {
          examText: "No",
          examValue: "No",
        },
      ],
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      allContainersDataArray: [],
      showSumaryArray: [],
      doc_master: [],
      docURL: URL_BASE_DOC,
      singleUpload: null,
      singleUpload: null,
      showAdd: true,
      isValidContainer: false,
      containerNoRegexError: "",
      conAlreadyExists: "",
      showAlgo: "",
      algoConNo: "",
      allModuleId: this.allModuleIdContainer,
      containerModal: {
        EnabledContainerFeild: false,
        containerNoUpdateCounter: "",
        shipmentType: "",
        containerInfo: "",
        multipleContainerTypeId: "",
        transportType: "",
        jobType: "",
        UpdateReason: "",
        importFreeDaysUpto: "",
        importPortETAorRailOutDt: "",
        importCFSorArrivalDt: "",
        allModuleId: "",
        clientId: "",

        netWeight: "",
        measurement: "",

        uniqueContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",

        weightUnit: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",

        PickupLocation: "",
        StuffingLocation: "",
        handoverDate: "",
        pickupDate: "",
        stuffingDate: "",
        shipperInvoiceNo: "",
        shipperInvoiceDate: "",
        shippingBillNo: "",
        shippingBillDate: "",

        examinationComplete: "",
        examDate: "",
        LetExportDate: "",

        //CC
        containerBookingNo: "",
        cartingDate: "",
        crnNo: "",
      },
      timmerMsg: "",
      checkContNoButton: 1,
    };
  },
  //this.$route.params.moduleId?this.$route.params.moduleId:
  mounted() {
    this.getData();
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {
    disableContainer() {
      if (this.JOB == "FF" && this.assignmentType == "Export") {
        return this.assignmentJobType.includes("TPT") ||
          this.assignmentJobType.includes("CC")
          ? true
          : false;
      }
      if (this.JOB == "CC" && this.assignmentType == "Export") {
        return this.assignmentJobType.includes("TPT") ? true : false;
      }
      if (this.JOB == "FF" && this.assignmentType == "Import") {
        return this.assignmentJobType.includes("CC") ? true : false;
      }
    },
    // assignmentType == 'Export' &&
    //                       (assignmentJobType.includes('TPT') ||
    //                         assignmentJobType.includes('CC'))
    //                         ? true
    //                         : false
  },
  watch: {
    checkAll: {
      handler(newVal, oldVal) {
        if (this.checkAll == "1") {
          for (let i = 0; i < this.allContainersDataArray.length; i++) {
            console.log(this.allContainersDataArray[i].uniqueContainerId);
            if (this.allContainersDataArray[i].uniqueContainerId) {
              this.singleSelectContainer.push(
                this.allContainersDataArray[i].uniqueContainerId
              );
            }
          }
        } else {
          this.singleSelectContainer = [];
        }
        console.log(this.singleSelectContainer, "yyy");
      },
      deep: true,
    },
    containerModal: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.containerModal.containerNo = newVal.containerNo.toUpperCase();
          this.containerNoRegexfun();
        }

        if (this.containerModal.packageId != "") {
          let arrayNew = this.packageNameList.filter((x) => {
            return x.packageId == this.containerModal.packageId;
          });

          if (arrayNew.length > 0) {
            this.containerModal.packageName = arrayNew[0].packageName;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    closeModalConfirm() {
      this.$refs["modal-close-conf"].hide();
    },
    openModalConfirm() {
      this.$refs["modal-close-conf"].show();
    },
    showModal(id, index) {
      this.$refs["my-modal-con"].show();

      let array = this.allContainersDataArray.filter((x) => {
        return x.uniqueContainerId == id;
      });

      Object.keys(this.containerModal).map((x) => {
        this.containerModal[x] = array[0][x];
      });
      if(this.containerModal.containerNo){
        this.isValidContainer=false;
        this.checkContNoButton=1;
      }
    },
    hideModal() {
      this.singleSelectContainer = [];
      this.checkAll = "0";
      this.$refs["my-modal-con"].hide();
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    containerNoRegexfun_bak() {
      this.isValidContainer = false;
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let array = [];
      if (this.containerModal.ffExecutionContainerId == "") {
        array = this.allContainersDataArray.filter((x) => {
          return x.containerNo == this.containerModal.containerNo;
        });
      }

      if (array.length > 0 && this.containerModal.uniqueContainerId == "") {
        this.containerNoRegexError = "Already Exist";
      } else if (containerformat.test(this.containerModal.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.isValidContainer = true;
        this.containerNoRegexError = "Enter Valid Container No.";
      }
      if (this.containerModal.containerNo) {
        let arrayConta = this.allContainersDataArray.filter((p) => {
          return p.containerNo == this.containerModal.containerNo;
        });

        if (arrayConta.length > 0) {
          this.conAlreadyExists = "Container No. Already Added";
        } else {
          this.conAlreadyExists = "";
        }
      }
    },
   validateContainerNumber(containerNumber) {
    // Check if the length is 11
    console.log("containerNumber.length=>",containerNumber.length)
    if (containerNumber.length !== 11) {
        return true;
    }

    // Check if the first 4 characters are alphabetic
    const prefix = containerNumber.slice(0, 4);
    const isText = /^[A-Z]+$/i.test(prefix); // Regex to check if first 4 characters are alphabetic
    
    // Check if the last 7 characters are digits
    const digits = containerNumber.slice(4);
    const isNumeric = /^\d{7}$/.test(digits); // Regex to check if last 7 characters are digits
   
    // Return true if both conditions are met, otherwise false
    return isText && isNumeric;
},
    async containerNoRegexfun() {
      this.isValidContainer = false;
      this.showAlgo = true;
      this.validate = false;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      let array = [];
      if (this.containerModal.ffExecutionContainerId == "") {
        array = this.allContainersDataArray.filter((x) => {
          return x.containerNo == this.containerModal.containerNo;
        });
      }
      if (
        this.containerModal.shipmentType == "1" &&
        this.containerModal.multipleContainerTypeId == "15" &&
        this.containerModal.transportType == "Export" &&
        this.containerModal.jobType.indexOf("FF") >= 0 &&
        this.containerModal.containerInfo == "lcl"
      ) {
        if (array.length > 0 && this.containerModal.uniqueContainerId == "") {
          this.containerNoRegexError = "";
        } else if (containerformat.test(this.containerModal.containerNo)) {
          this.containerNoRegexError = "";
          this.validate = false;
        } else {
          this.isValidContainer = true;
          this.containerNoRegexError = "Enter Valid Container No.";
          this.validate = true;
        }
        if (this.containerModal.containerNo) {
          let arrayConta = this.allContainersDataArray.filter((p) => {
            return p.containerNo == this.containerModal.containerNo;
          });

          if (arrayConta.length > 0) {
            this.conAlreadyExists = "";
          } else {
            this.conAlreadyExists = "";
          }
        }
      } else {
        let checkValueExit = await this.checkContainerNoExist();
        if (array.length > 0 && this.containerModal.uniqueContainerId == "") {
          if (!checkValueExit) {
            this.containerNoRegexError = this.containerNoRegexError;
          } else {
            this.containerNoRegexError = "";
            this.containerNoRegexError = "Already Exist";
          }
        } else if (containerformat.test(this.containerModal.containerNo)) {
          if (!checkValueExit) {
            this.containerNoRegexError = this.containerNoRegexError;
            this.validate = false;
          } else {
            this.containerNoRegexError = "";
            this.validate = false;
          }
        } else {
          let checkStatus =false;
          if(this.containerModal.containerNo &&this.containerModal.uniqueContainerId){

            checkStatus = this.validateContainerNumber(this.containerModal.containerNo);
          }
          this.isValidContainer = true;
          this.containerNoRegexError = "Enter Valid Container No.";
          this.validate = true;
        }
        if (this.containerModal.containerNo) {
          let arrayConta = this.allContainersDataArray.filter((p) => {
            return p.containerNo == this.containerModal.containerNo;
          });

          if (arrayConta.length > 0) {
            // let checkValueExit = await this.checkContainerNoExist();
            if (!checkValueExit) {
              // this.conAlreadyExists = this.containerNoRegexError;
            } else {
              this.conAlreadyExists = "";
              this.conAlreadyExists = "Container No. Already Added";
            }
          } else {
            this.conAlreadyExists = "";
          }
        }
      }
    },
    CheckContainerNumber() {
      this.isValidContainer = false;
      if (
        this.containerModal.containerNo &&
        this.allModuleIdContainer &&
        this.containerModal.uniqueContainerId
      ) {
        let payload = {
          allModuleId: this.allModuleIdContainer,
          containerNo: this.containerModal.containerNo,
          containerID: this.containerModal.uniqueContainerId,
          itemCode: "CheckContainerNumber",
          type: "Check",
        };

        this.timmerMsg = "Please Wait - Searching Container Number";

        setTimeout(() => {
          CommonService.getCheckBLDetails(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.FLAG != "" && data.FLAG != undefined) {
                this.timmerMsg = data.MSG;
                this.checkContNoButton = data.FLAG;
              } else {
                // this.alert.content = data.MSG;
              }
              this.isLoading = false;
            })

            .catch((error) => {
              console.log("Catch on getDatacheck - CheckCOntainerNumber Error: ", error);
            });
        }, 2000);
      }
    },
    checkContainerNoExist() {
      // alert(this.allModuleIdContainer);
      return new Promise((resolve) => {
        let option_details = {
          module_type: "FF Export",
          containerNo: this.containerModal.containerNo,
          goodReceivedID: "",
          allModuleId: this.allModuleIdContainer,
        };
        // alert(this.option_details.length);
        console.log("option_details=>", option_details);
        if (option_details != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkContainerNoExist.php`,
            data: JSON.stringify(option_details),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                // alert(data.find);
                if (data.find == 1) {
                  this.ContainernoErrFlag = true;
                  this.containerNoRegexError = data.MSG;
                  this.OldAssSeries_Containerno = "";
                  //  if(this.goodReceived.containerNo == data.containerNo){
                  //     this.containerNoRegexError = '';
                  //  }
                } else if (data.find == 0) {
                  this.ContainernoErrFlag = false;
                  this.containerNoRegexError = "";
                }

                this.syncFlag = true;
                console.log("Check");
                return resolve(!this.ContainernoErrFlag);
              }
            })
            .catch((error) => {});
        }
      });
    },

    getConAlgoList() {
      if (this.containerModal.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(this.containerModal.containerNo);
      }
    },
    submitContainer() {
      this.containerNoRegexfun();
      // alert(this.validate)
      if (this.validate == true) {
        this.openModalConfirm();
        return false;
      }
      if (this.validate == false) {
        this.containerModal.containerNoUpdateCounter =
          parseInt(this.containerModal.containerNoUpdateCounter) + parseInt(1);
        let payload = {
          containerModal: this.containerModal,
          selectedContainerArray: this.singleSelectContainer,
        };
        // console.log(payload);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addContainerModuleDetails_NewV3.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data) {
              this.singleUpload = "";
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    downloadZip() {
      let payload = {
        upload_dir_folderName: this.JOBSERIES.replaceAll("/", "_"),
      };
      NodeLockPannelService.downloadAssignmentZipNode(payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${payload.upload_dir_folderName}.zip`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error("Download Error:", error);
        });
    },
    downloadDocs(url, filename) {
      fetch(url).then(function (t) {
        return t.blob().then((b) => {
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
        });
      });
    },

    addMoreDoc() {
      this.showAdd = false;
      let obj = {
        documentName: "",
        documentLink: "",
        docRemarks: "",
        addedFromMain: "1",
        allModuleId: this.allModuleIdContainer,
      };

      //this.$route.params.moduleId?this.$route.params.moduleId:
      this.docArray.push(obj);
      this.docArray.reverse();
    },
    onFileChange(index, item) {
      this.isLoading = true;
      var files = event.target.files || event.dataTransfer.files;
      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "staticFileName",
          "Doc-" + item.documentName + this.allContainersDataArray.length
        );
        formData.append(
          "upload_dir_folderName",
          this.JOBSERIES.replaceAll("/", "_")
          // this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.allContainersDataArray[index].singleUpload = result.data;
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    getData() {
      this.showAdd = true;
      this.isLoading = true;
      this.allContainersDataArray = [];

      let payload = {
        allModuleId: this.allModuleIdContainer,
        JOB: this.JOB,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getAllAssignmentContaier_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "sfsfrererere");

            if (data.allContainersDataArray.length > 0) {
              this.allContainersDataArray = data.allContainersDataArray;
            }
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }
            if (data.LocationDetailsFinal.length > 0) {
              this.pickUpList = data.LocationDetailsFinal;
              this.handoverList = data.LocationDetailsFinal;
            }
            if (data.executionData.length > 0) {
              this.assignmentJobType = data.executionData[0].jobType.split(",");
              this.assignmentType = data.executionData[0].transportType;
            }
            if (this.TYPE != "IMPORT") {
              let arryDone = this.allContainersDataArray.filter((x) => {
                return (
                  !x.containerNo ||
                  !x.grossWeight ||
                  !x.weightUnit ||
                  !x.shipperInvoiceNo ||
                  !x.shipperInvoiceDate ||
                  !x.shippingBillNo ||
                  !x.shippingBillDate
                );
              });
              if (arryDone.length > 0) {
                this.$sessionsStorage.set("completed", "0");
                this.$store.dispatch("setContainerList", "0");
              } else {
                this.$store.dispatch("setContainerList", "1");
              }
            } else {
              let arryDone = this.allContainersDataArray.filter((x) => {
                return !x.containerNo;
              });
              if (arryDone.length > 0) {
                this.$sessionsStorage.set("completed", "0");
                this.$store.dispatch("setContainerList", "0");
              } else {
                this.$store.dispatch("setContainerList", "1");
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f; /* Bootstrap danger color */
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite; /* Adjust the duration as needed */
}
</style>



// WEBPACK FOOTER //
// containerComponent.vue?acc5d258